(ns re-frame.db
  (:require [re-frame.interop :refer [ratom]]))

;; -- Application State  --------------------------------------------------------------------------
;;
;; Should not be accessed directly by application code.
;; Read access goes through subscriptions.
;; Updates via event handlers.
(def ^:dynamic app-db (ratom {}))
